// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5gYk1","content":"styles_content___M0-D"};